import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ws-input',
  templateUrl: './ws-input.component.html',
  styleUrls: ['./ws-input.component.scss']
})
export class WsInputComponent {

  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() value: string = '';
  @Input() name: string = '';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;
  @Input() inputMode?: string;
  @Input() pattern?: string;
  @Input() invalid: boolean = false;
  @Input() touched: boolean = false;
  @Input() permission?: string;
  
  @Output() onValueChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() onFocus: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onBlur: EventEmitter<Event> = new EventEmitter<Event>();

  constructor() {}
  
  onInputChange(event: Event) {
    this.onValueChanged.emit((event.target as HTMLInputElement).value);
  }

  onFocusInternal(event: Event) {
    this.onFocus.emit(event);
  }

  onBlurInternal(event: Event) {
    this.onBlur.emit(event);
  }

}
